import React, { Fragment, useEffect, useState } from 'react';
import { css } from 'twin.macro';
import { BiTime, BiArrowBack } from 'react-icons/bi';
import dayjs from 'dayjs';
import PreviewEventModal from '../../Admin/Tasks/PreviewEventModal';
import { fetchWrapper, getDemandableDateString } from '../../../_helpers';
import { toast } from 'react-toastify';

import { Form, Col, Button } from 'react-bootstrap';
import { AdminTable } from '../../Admin/reusableStyles';

import DateTimePicker from 'react-datetime-picker';
import { TiTick, TiMinus } from 'react-icons/ti';
import { connect } from 'react-redux';

import { getPublicTaskPackage, updateTaskFormOnAddRemove, getTheTask } from '../../../_redux/actions/ActionTasks';
import { VscLoading } from 'react-icons/vsc';
import Avatar from '@/components/Admin/reusableComponents/Avatar';
import { BsFillLockFill } from 'react-icons/bs';

const eventsContainer = css`
    position: absolute;
    top: 60px;
    right: 56px;
    background-color: #ffffff;
    width: 500px;
    padding: 1rem;
    overflow-y: auto;
    border-radius: 6px;
    overflow: clip;
    box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.6);
`;

const chatroomEvent = css`
    display: flex;
    border-bottom: 3px solid #f5f5f5;
    margin-bottom: 2rem;
    padding: 1% 1rem;

    h4 {
        font-size: 17px;
        cursor: pointer;
    }
`;

const eventTypeIcon = css`
    width: 40px;
    height: 40px;
    border-radius: 50%;
`;

const PublicChannelEvents = ({
    label,
    chatroomEvents,
    getPublicTaskPackage,
    updateAssignedUsers,
    userID,
    areEventsFetching,
    updateTaskFormOnAddRemove,
    getTheTask,
    activeEvent,
    handleHideEventsModal,
}) => {
    const [showModal, setShowModal] = useState(null);
    const [showEventContent, setShowEventContent] = useState(false);
    const [addOrRemoveEvents, setAddOrRemoveEvents] = useState();
    const [clickedEvent, setClickedEvent] = useState({});

    const [showDemandDate, setShowDemandDate] = useState([]);
    const [demandedDate, setDemandedDate] = useState({ demandDate: new Date(), demandDueDate: new Date() });
    const [demandedDateForAP, setDemandedDateForAP] = useState({});

    const [shouldDisableButtons, setshouldDisableButtons] = useState(false);

    useEffect(() => {
        if (clickedEvent.taskData) {
            setDemandedDateForAP(
                Object.fromEntries(
                    clickedEvent.taskData.map((task) => [
                        task._id,
                        {
                            demandDate: task.demandDate ? new Date(task.demandDate) : new Date(),
                            demandDueDate: task.demandDueDate ? new Date(task.demandDueDate) : new Date(),
                        },
                    ])
                )
            );
        }
    }, [clickedEvent]);

    const sortChatroomEventsByDate = chatroomEvents
        ?.filter((task) => task?.status !== 'done')
        ?.sort((a, b) => {
            const dateA = dayjs(a.date);
            const dateB = dayjs(b.date);
            return dateB - dateA;
        });

    const handleShowEvent = async (event) => {
        const id = event?._id || event?.id || event;
        await getTheTask(id);
        setShowModal(id);
    };
    const handleEventClose = () => {
        setShowModal(null);
    };
    const handleClosed = () => {
        setShowModal(null);
    };

    const selectedTasks = clickedEvent?.taskData?.map((task) => ({
        label: task.title,
        value: task._id,
        start: task.date,
        end: task.dueDate,
        ...task,
    }));

    const handlePackageEventClick = async (event, mode = 'add') => {
        setshouldDisableButtons(true);
        const eventPackage = event?.eventPackage?._id ? event.eventPackage : await getPublicTaskPackage(event?._id);
        setClickedEvent(eventPackage);
        setShowEventContent(true);
        setAddOrRemoveEvents(mode);
        setshouldDisableButtons(false);
    };

    const handleAddPackageToCalendar = async (id) => {
        try {
            setshouldDisableButtons(true);
            const dateValues = Object.values(demandedDateForAP);
            dateValues.forEach((date) => {
                if (date === null || date === undefined) {
                    throw new Error('The Date Field cannot be empty');
                }
            });

            const res = await fetchWrapper.put(`activityPackages/map/${id}`, { demandDates: demandedDateForAP });
            res.forEach((task) => {
                updateAssignedUsers(task?._id || task?.id, task?.assignedUser);
                updateTaskFormOnAddRemove(task);
            });
            // setShowEventContent(false);
            toast.success('Event assigned succesfully');
        } catch (err) {
            toast.error(err.message || err.error);
            console.log(err);
        } finally {
            setshouldDisableButtons(false);
        }
    };

    const handleRemovePackageFromCalendar = async (id) => {
        try {
            setshouldDisableButtons(true);
            const res = await fetchWrapper.put(`activityPackages/map/remove/${id}`);
            res.forEach((task) => {
                updateAssignedUsers(task?._id || task?.id, task?.assignedUser);
                updateTaskFormOnAddRemove(task);
            });
            setShowEventContent(false);
            toast.success('User Removed sucessfully');
        } catch (err) {
            toast.error(err.message || err.error);
            console.log(err);
        } finally {
            setshouldDisableButtons(false);
        }
    };

    const toogleDemandedDate = (id) => {
        setShowDemandDate((prevState) => {
            if (prevState.includes(id)) {
                return prevState.filter((item) => item !== id);
            } else {
                return [...prevState, id];
            }
        });
    };

    const handleAddToCalendar = async (id) => {
        try {
            if (!id) {
                return;
            }
            setshouldDisableButtons(true);
            const resp = await fetchWrapper.put(`task/map/${id}`, demandedDate);
            resp?.assignedUser && updateAssignedUsers(id, resp?.assignedUser);
            resp?.assignedUser?.length && updateTaskFormOnAddRemove(resp);
            toast.success('Event assigned succesfully.');
            resp?.eventMode === 'onDemand' && toogleDemandedDate(id);
            setDemandedDate({ demandDate: new Date(), demandDueDate: new Date() });
            handleShowEvent(id);
        } catch (err) {
            toast.error(err.message);
            console.log(err);
        } finally {
            setshouldDisableButtons(false);
        }
    };
    const removeAddToCalendar = async (id) => {
        try {
            if (!id) {
                return;
            }
            setshouldDisableButtons(true);
            const resp = await fetchWrapper.put(`task/map/remove/${id}`);
            updateAssignedUsers(id, resp?.assignedUser);
            updateTaskFormOnAddRemove(resp);
            toast.success('User removed from Event');
        } catch (err) {
            toast.error(err.message);
            console.log(err);
        } finally {
            setshouldDisableButtons(false);
        }
    };

    const handleDateTimeChange = (eventId, date, dueDate) => {
        setDemandedDateForAP((prevDates) => ({
            ...prevDates,
            [eventId]: {
                demandDate: date || prevDates[eventId]?.demandDate || Date.now(),
                demandDueDate: dueDate || prevDates[eventId]?.demandDueDate || Date.now(),
            },
        }));
    };
    const isUserPresentInOnDemandSubchannelTask = (event) =>
        event?.subChannelTasks?.find((subTask) => {
            if (subTask?.user === userID) {
                return true;
            }
            return false;
        });

    return (
        <div css={eventsContainer}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <span onClick={handleHideEventsModal} style={{ cursor: 'pointer' }}>
                    X
                </span>
            </div>
            {activeEvent?._id ? (
                <h1 className="text-center font-weight-bold text-capitalize opto-text mb-4"> Event Details </h1>
            ) : (
                <h1 className="text-center font-weight-bold text-capitalize opto-text mb-4"> {label || ''} Events </h1>
            )}
            {showEventContent ? (
                <div>
                    <BiArrowBack
                        style={{ width: '50px', height: '36px' }}
                        onClick={() => {
                            setShowEventContent(false);
                        }}
                        className="icon view"
                    />
                    {/* Render the event details */}
                    <Form.Group as={Col} md={12}>
                        <Form.Label>Plan Name</Form.Label>
                        <Form.Control type="text" value={clickedEvent?.name} name="packageName" readOnly />
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md={12}
                        css={css`
                            max-height: 60vh;
                            overflow-y: auto;
                        `}
                    >
                        <AdminTable
                            className="mb-5 w-100"
                            css={css`
                                position: relative;
                            `}
                        >
                            <thead
                                css={css`
                                    position: sticky;
                                    top: 0;
                                    z-index: 1;
                                `}
                            >
                                <tr>
                                    <th style={{ padding: '0 2px' }}>S.N.</th>
                                    <th style={{ padding: '0 2px' }}>Event Name</th>
                                    <th style={{ padding: '0 2px' }}>Dates</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedTasks?.map((event, index) => {
                                    return (
                                        <tr key={event._id}>
                                            <td className="text-left py-1 pl-0 pr-1">{index + 1}</td>
                                            <td
                                                className=" text-left py-1 pl-0 pr-1 pointer"
                                                onClick={() => handleShowEvent(event)}
                                                css={css`
                                                    max-width: 140px;

                                                    &:hover {
                                                        font-weight: 600;
                                                        color: #24627e;
                                                    }
                                                `}
                                            >
                                                {event.title}
                                            </td>
                                            <td className="text-left py-1 pl-0 pr-1">
                                                {event?.eventMode === 'live' ? (
                                                    dayjs(event.latestDatePointer || event.date).format(
                                                        'MM-DD-YYYY h:mm A'
                                                    )
                                                ) : (
                                                    <div style={{ fontSize: '14px' }}>
                                                        <DateTimePicker
                                                            minDate={
                                                                new Date(
                                                                    Math.max(
                                                                        new Date(),
                                                                        new Date(event.latestDatePointer || event.date)
                                                                    )
                                                                )
                                                            }
                                                            onChange={(date) =>
                                                                handleDateTimeChange(
                                                                    event._id,
                                                                    date,
                                                                    date && new Date(new Date(date) + event.duration)
                                                                )
                                                            }
                                                            value={
                                                                demandedDateForAP[event._id]?.demandDate
                                                                    ? new Date(demandedDateForAP[event._id].demandDate)
                                                                    : null
                                                            }
                                                            disabled={addOrRemoveEvents === 'remove'}
                                                            format="MM-dd-y hh:mm a"
                                                            disableClock={true}
                                                            calendarType={'US'}
                                                        />
                                                    </div>
                                                )}
                                                {event?.eventMode === 'live' ? (
                                                    dayjs(event.latestDueDatePointer || event.dueDate).format(
                                                        'MM-DD-YYYY h:mm A'
                                                    )
                                                ) : (
                                                    <div style={{ fontSize: '14px' }}>
                                                        <DateTimePicker
                                                            minDate={
                                                                new Date(
                                                                    Math.max(
                                                                        new Date(),
                                                                        new Date(event.latestDatePointer || event.date)
                                                                    )
                                                                )
                                                            }
                                                            onChange={(date) =>
                                                                handleDateTimeChange(event._id, null, date)
                                                            }
                                                            value={
                                                                demandedDateForAP[event._id]?.demandDueDate
                                                                    ? new Date(
                                                                          demandedDateForAP[event._id].demandDueDate
                                                                      )
                                                                    : null
                                                            }
                                                            disabled={true}
                                                            // disabled={addOrRemoveEvents === 'remove'}
                                                            format="MM-dd-y hh:mm a"
                                                            disableClock={true}
                                                            calendarType={'US'}
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                            {showModal === (event?._id || event?.id || event) ? (
                                                <PreviewEventModal data={event} handleClose={handleEventClose} />
                                            ) : null}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </AdminTable>
                    </Form.Group>

                    <div className="d-flex justify-content-end">
                        <Button
                            onClick={() => {
                                addOrRemoveEvents === 'add'
                                    ? handleAddPackageToCalendar(clickedEvent?.id)
                                    : handleRemovePackageFromCalendar(clickedEvent?.id);
                            }}
                            disabled={shouldDisableButtons}
                        >
                            {addOrRemoveEvents === 'add' ? 'Add to Calendar' : 'Remove from Calendar'}
                        </Button>
                    </div>
                </div>
            ) : (
                <div
                    style={{
                        position: 'relative',
                        overflow: areEventsFetching ? 'hidden' : 'auto',
                        maxHeight: '580px',
                    }}
                >
                    {areEventsFetching ? (
                        <VscLoading
                            style={{
                                fontSize: '36px',
                                textAlign: 'center',
                                width: '100%',
                                margin: '12px',
                            }}
                            className="spin"
                        />
                    ) : chatroomEvents && sortChatroomEventsByDate?.length > 0 ? (
                        sortChatroomEventsByDate.map((event, index) => {
                            const isEditableEvent = event?.isPublicTask || event?.eventMode === 'onDemand';
                            return (
                                <div key={index} css={chatroomEvent}>
                                    {event?.eventType?.image ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={event?.eventType?.image}
                                                alt={event?.eventType?.name}
                                                css={eventTypeIcon}
                                            />
                                        </div>
                                    ) : (
                                        <Avatar item={event?.eventType || event} />
                                    )}
                                    <div className="ml-4" style={{ display: 'flex', flexDirection: 'column' }}>
                                        <h4
                                            className="font-weight-bold text-capitalize opto-text  flex-row gap-2 "
                                            onClick={() => {
                                                handleShowEvent(event);
                                            }}
                                        >
                                            {event?.title}
                                            {event?.eventPackage ? (
                                                <span
                                                    className="badge badge-warning"
                                                    css={css`
                                                        margin-left: 4px;
                                                        text-transform: lowercase;
                                                    `}
                                                >
                                                    plan
                                                </span>
                                            ) : null}
                                            {event?.eventMode === 'onDemand' ? (
                                                <span
                                                    className="badge badge-warning"
                                                    css={css`
                                                        margin-left: 4px;
                                                        text-transform: lowercase;
                                                    `}
                                                >
                                                    on-demand
                                                </span>
                                            ) : null}
                                            {event?.eventMode === 'live' ? (
                                                <span
                                                    className="badge badge-danger"
                                                    css={css`
                                                        margin-left: 4px;
                                                        text-transform: lowercase;
                                                    `}
                                                >
                                                    live
                                                </span>
                                            ) : null}
                                        </h4>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <BiTime />
                                            <span className="ml-2 font-italic">
                                                {event?.eventMode === 'onDemand' ? (
                                                    <div>
                                                        {!!isUserPresentInOnDemandSubchannelTask(event) ? (
                                                            <div>
                                                                {dayjs(
                                                                    isUserPresentInOnDemandSubchannelTask(event)
                                                                        ?.demandDate
                                                                ).format('MM-DD-YYYY h:mm A')}
                                                            </div>
                                                        ) : (
                                                            getDemandableDateString(event)
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {dayjs(event?.latestDatePointer).format('MM-DD-YYYY h:mm A')}
                                                    </div>
                                                )}
                                            </span>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'start',
                                                gap: '5px',
                                            }}
                                        >
                                            <div
                                                className="d-flex align-items-center"
                                                style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}
                                            >
                                                {isEditableEvent ? (
                                                    <Fragment>
                                                        {event?.eventPackage?.length ||
                                                        event?.eventPackage?._id?.length > 0 ? (
                                                            !event.assignedUser?.includes(userID) ? (
                                                                <>
                                                                    <Button
                                                                        onClick={() =>
                                                                            handlePackageEventClick(event, 'add')
                                                                        }
                                                                        disabled={shouldDisableButtons}
                                                                    >
                                                                        Add Plan to Calendar
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Button
                                                                        onClick={() =>
                                                                            handlePackageEventClick(event, 'remove')
                                                                        }
                                                                        disabled={shouldDisableButtons}
                                                                    >
                                                                        Remove Plan from Calendar
                                                                    </Button>
                                                                </>
                                                            )
                                                        ) : !event.assignedUser?.includes(userID) ? (
                                                            <Button
                                                                onClick={() =>
                                                                    event?.eventMode === 'onDemand'
                                                                        ? toogleDemandedDate(event?._id)
                                                                        : handleAddToCalendar(event?._id)
                                                                }
                                                                disabled={shouldDisableButtons}
                                                            >
                                                                Add to Calendar
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                disabled={shouldDisableButtons}
                                                                onClick={() => removeAddToCalendar(event?._id)}
                                                            >
                                                                Remove from Calendar
                                                            </Button>
                                                        )}
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        <span className="badge badge-info">
                                                            <BsFillLockFill className="mr-2" />
                                                            Assigned To Event
                                                        </span>
                                                    </Fragment>
                                                )}

                                                {showDemandDate.includes(event?._id) && (
                                                    <>
                                                        <button
                                                            disabled={shouldDisableButtons}
                                                            onClick={() => handleAddToCalendar(event?._id)}
                                                            className={`
															add-to-calendar-tick-button 
															${shouldDisableButtons ? ' disabled ' : ''}`}
                                                        >
                                                            <TiTick size={20} className="tick-icon" />
                                                        </button>

                                                        <button
                                                            disabled={shouldDisableButtons}
                                                            onClick={() => toogleDemandedDate(event?._id)}
                                                            className="add-to-calendar-cancel-button"
                                                        >
                                                            <TiMinus size={20} className="cancel-icon" />
                                                        </button>
                                                    </>
                                                )}
                                            </div>

                                            {showDemandDate.includes(event?._id) && (
                                                <div
                                                    className="d-flex"
                                                    css={css`
                                                        flex-direction: column;
                                                    `}
                                                >
                                                    <DateTimePicker
                                                        onChange={(date) =>
                                                            setDemandedDate((prev) => ({
                                                                ...prev,
                                                                demandDate: date,
                                                                demandDueDate:
                                                                    date &&
                                                                    new Date(new Date(date).valueOf() + event.duration),
                                                            }))
                                                        }
                                                        value={demandedDate.demandDate}
                                                        format="MM-dd-y hh:mm a"
                                                        disableClock={true}
                                                        calendarType={'US'}
                                                        minDate={
                                                            new Date(
                                                                Math.max(
                                                                    new Date(),
                                                                    new Date(event.latestDatePointer || event.date)
                                                                )
                                                            )
                                                        }
                                                    />
                                                    <DateTimePicker
                                                        onChange={(date) =>
                                                            setDemandedDate((prev) => ({
                                                                ...prev,
                                                                demandDueDate: date,
                                                            }))
                                                        }
                                                        value={demandedDate.demandDueDate}
                                                        format="MM-dd-y hh:mm a"
                                                        disableClock={true}
                                                        calendarType={'US'}
                                                        minDate={
                                                            new Date(
                                                                Math.max(
                                                                    new Date(),
                                                                    new Date(event.latestDatePointer || event.date)
                                                                )
                                                            )
                                                        }
                                                        disabled
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {showModal === (event?._id || event?.id || event) && (
                                        <PreviewEventModal data={event} handleClose={handleClosed} />
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div className="mt-4">
                            <h2 className="text-center font-weight-bold text-capitalize ">No Events</h2>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    userID: state.user.user._id,
});

export default connect(mapStateToProps, { getPublicTaskPackage, updateTaskFormOnAddRemove, getTheTask })(
    PublicChannelEvents
);
